// src/utils/renderPreviewComponent.js
import React from 'react';
import { Copy, ExternalLink } from 'lucide-react';
import { copyText, showCenterToast } from './copyToClipboard';

export const renderPreviewComponent = (component, onImageClick) => {
  switch (component.type) {
    case 'title':
      return (
        <h1 className={`${component.content.fontSize} ${component.content.color} ${component.content.isBold ? 'font-bold' : 'font-normal'} font-bold mb-4 text-center`}>
          {component.content.text}
        </h1>
      );
    case 'text':
      return (
        // <p className="text-gray-700 mb-4 leading-relaxed text-center">
        //   {component.content}
        // </p>
        <p className={`${component.content.fontSize} ${component.content.color} ${component.content.isBold ? 'font-bold' : 'font-normal'} text-gray-700 mb-4 leading-relaxed text-center border-2 border-dashed border-gray-900 rounded-lg p-3`}
          style={{ whiteSpace: 'pre-line' }}
        >
          {component.content.text}
        </p>
      );
    case 'image':
      return (
        <img
          src={component.content}
          alt="内容图片"
          className="w-full max-w-md h-auto rounded-lg shadow-md mb-4 mx-auto cursor-pointer hover:shadow-lg transition-shadow"
          onClick={() => onImageClick(component.content)}
        />
      );
    case 'button':
      // 纯同步的点击处理逻辑
      const handleButtonClick = (buttonContent) => {  
        if (buttonContent.action === 'copy' && buttonContent.copyText) {

          // ✅ 直接使用导入的同步复制方法
          const isSuccess = copyText(buttonContent.copyText);

          if (isSuccess) {
            showCenterToast('已复制到剪贴板');
          } else {
            showCenterToast('复制失败，请手动复制', false);
          }

        } else if (buttonContent.action === 'link' && buttonContent.link) {
          const url = buttonContent.link.trim();
          if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
          }
        }
      };
      return (
        <button
          onClick={() => handleButtonClick(component.content)}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 mb-4 flex items-center justify-center space-x-2"
        >
          {component.content.text}
          {component.content.action === 'link' && <ExternalLink className="w-4 h-4" />}
          {component.content.action === 'copy' && <Copy className="w-4 h-4" />}
        </button>
      );
    default:
      return null;
  }
};